import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { Currency } from '../../constants/currency.js';
import { TERMS } from '../../constants/termsAndDuration.js';
import { getAmountString, humanizePriceRange } from '../../helpers/humanization.js';

const getStrakhovaniyeOtUkusaKleshchaTerms = item => {
    const conditions = [];
    // срок действия, страховая сумма, стоимость
    // срок действия
    const { time } = item;
    const termValue = `${time} ${pluralizeByUnit(time, TERMS.day)}`;
    conditions.push({ value: termValue, description: 'Срок действия', wide: true, key: 'term' });
    // страховая сумма
    const { sumRub } = item;
    const sumValue = getAmountString(sumRub, Currency.RUB, false);
    conditions.push({ value: sumValue, description: 'Страховая сумма', wide: true, key: 'sum' });
    // стоимость
    const { priceChild, priceAdult } = item;
    const priceValue = humanizePriceRange({
        priceRange: {
            from: priceChild,
            to: priceAdult,
        },
        allowZero: false,
    });
    conditions.push({ value: `${priceValue} в год`, description: 'Стоимость', wide: true, key: 'price' });
    return conditions;
};

export { getStrakhovaniyeOtUkusaKleshchaTerms };
//# sourceMappingURL=strakhovaniyeOtUkusaKleshcha.js.map
